import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'

// import http from '@/$plugins/http'

import base from '../base'
import CHANGE_REQUESTS from '../base/change-requests'
import MAINENTITY from '../base/entity-main'
import SEARCH from '../base/entity-search'
import IS from '../base/is'

export default {
  namespaced: true,
  state: base.createState(IS.state, CHANGE_REQUESTS.state, SEARCH.state, MAINENTITY.state, { /* define custom state-properties */ }),
  getters: base.createGetters(IS.getters, CHANGE_REQUESTS.getters, SEARCH.getters, MAINENTITY.getters, { /* define custom getters */ }),
  mutations: base.createMutations(IS.mutations, CHANGE_REQUESTS.mutations, SEARCH.mutations, MAINENTITY.mutations, { /* define custom mutations */ }),
  actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.order, STOREMODULE_ENDPOINT_MAP.graduatediscounts, IS.actions, CHANGE_REQUESTS.actions, SEARCH.actions, MAINENTITY.actions, {})
}
